"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconType = exports.EReliabilityStatus = exports.EReliabilityDetailType = void 0;
// Статус надежности
let EReliabilityStatus = exports.EReliabilityStatus = /*#__PURE__*/function (EReliabilityStatus) {
  EReliabilityStatus["Problem"] = "problem";
  EReliabilityStatus["Reliable"] = "reliable";
  return EReliabilityStatus;
}({});
let IconType = exports.IconType = /*#__PURE__*/function (IconType) {
  IconType["Success"] = "success";
  // Зеленая галочка
  IconType["InProgress"] = "inProgress";
  // Серая галочка
  IconType["Failure"] = "failure";
  // Красная галочка
  IconType["Warning"] = "warning"; // Оранжевый треугольник с восклицательным знаком
  return IconType;
}({});
let EReliabilityDetailType = exports.EReliabilityDetailType = /*#__PURE__*/function (EReliabilityDetailType) {
  EReliabilityDetailType["ProblemHousesRegistry"] = "problemHousesRegistry";
  EReliabilityDetailType["DeveloperBankruptStatus"] = "developerBankruptStatus";
  EReliabilityDetailType["ConstructionProgress"] = "constructionProgress";
  EReliabilityDetailType["Escrow"] = "escrow";
  EReliabilityDetailType["ConstructionPhoto"] = "constructionPhoto";
  return EReliabilityDetailType;
}({});